module.exports = __webpack_public_path__ + "static/media/IMG_0004.3fbd4794.jpg";